<template>
  <div style="min-width: 200px" class="bg-white rounded-1 p-2">
    <div class="d-flex align-items-center">
      <el-image style="width: 36px;height:36px" fit="cover" :src="thumb" class="mt-1 rounded-1" />
      <div class="mx-2 flex-1 mt-1">
        <span class="font-size-13 text-1-line-replied" style="white-space: pre-line">
          <span v-html="regexUrl(title)" />
        </span>
        <div v-if="phone">{{ phone }}</div>
      </div>
      <el-image v-if="qrCodeUrl" :src="qrCodeUrl" style="width: 64px" class="mx-2" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatRecommended",
  props: ["thumb", "qrCodeUrl", "phone", "title", "duration"],
  methods: {
    regexUrl(message) {
      let urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      let newMess = message.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
      return newMess.replace(urlRegex, function(url, b, c) {
        let url2 = (c == "www.") ? "http://" + url : url;
        return "<a class=\"color-blue\" href=\"" + url2 + "\" target=\"_blank\">" + url + "</a>";
      });
    }
  }
};
</script>

<style scoped>

</style>
